import { render, staticRenderFns } from "./ProductSignLook.vue?vue&type=template&id=21abcf4a&scoped=true&"
import script from "./ProductSignLook.vue?vue&type=script&lang=js&"
export * from "./ProductSignLook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21abcf4a",
  null
  
)

export default component.exports